// Lowercase component types sent by the older, pre-@atlas/react-forms backend
// forms, alongside the newer uppercase FIELD_COMPONENTS enum.
export const LEGACY_FIELD_COMPONENTS = {
  CHECKBOX: 'checkbox',
  COUNTRYPICKER: 'countrypicker',
  DAYPICKER: 'daypicker',
  DEPOSIT_INPUT: 'depositInput',
  FILE: 'file',
  MONEY_INPUT: 'moneyInput',
  PASSWORD: 'password',
  RADIOSELECT: 'radioselect',
  SELECT: 'select',
  TEXT: 'text',
};
